import { IConfigsType } from '../../types'

const fwWingstopAiBlackbox: IConfigsType = {
  'fw_wingstop-expo-admin': {
    '/:brand/ai_blackbox': {
      groupFilter: {
        api: 'fwWingstopCorporateFilter',
      },
      dateFilter: {
        types: ['yesterday', 'this_week', 'last_week', 'week', 'custom'],
        defaultType: 'yesterday',
        isDailyCustom: true,
      },
      title: {
        type: 'title',
        title: 'AI Blackbox',
      },
      aiBlackbox: {
        type: 'ai-blackbox-wrapper',
        contentPartNames: [
          'expoTableExample',
          'expoFwOpsReportHalfRebuild',
          'tester',
        ],
        hasDateFilter: true,
        hasGroupFilter: true,
      },
    },
  },
}

export default fwWingstopAiBlackbox
